import VectorSource from 'ol/source/Vector';
import { MapInstance } from '@/types/map';
import { LayerImageAdapter } from '@/utils/layer/LayerImageAdapter';
import { LayerTextAdapter } from '@/utils/layer/LayerTextAdapter';
import { LayerRectAdapter } from '@/utils/layer/LayerRectAdapter';
import { LayerOvalAdapter } from '@/utils/layer/LayerOvalAdapter';
import { LayerLineAdapter } from '@/utils/layer/LayerLineAdapter';

export default function updateElement(
  mapInstance: MapInstance,
  layerId: number,
  layerObject:
    | LayerImageAdapter
    | LayerTextAdapter
    | LayerRectAdapter
    | LayerOvalAdapter
    | LayerLineAdapter,
): void {
  mapInstance?.getAllLayers().forEach(layer => {
    if (layer.get('id') === layerId) {
      const source = layer.getSource();
      if (source instanceof VectorSource) {
        const feature = source.getFeatureById(layerObject.getId());
        const update = feature?.get('updateElement');
        if (update && update instanceof Function) {
          update(layerObject);
          feature.changed();
        }
      }
    }
  });
}
